const SET_DATA = 'teams/SET_DATA';
const SET_ARTICLE_DATA = 'teams/SET_ARTICLE_DATA';

export const setData = (event: any ) => ({ type: SET_DATA, payload: event });
export const setArticleDataToStore = (event: any) => ({ type: SET_ARTICLE_DATA, payload: event });
type Action = {
  type: string;
  payload?: any;
};

export type ArticleDataProps = {
  type: string;
  date: number;
  image: string;
  title: string;
  intro: string;
  description: string;
  image_copyright_text: string;
  articleslug: string;
  isShared: boolean;
}

export type InitialState = {
    articleData: ArticleDataProps[];
};

const INITIAL_STATE: InitialState = {
  articleData: [],
};

function reducer(state: InitialState = INITIAL_STATE, action: Action) {
  switch (action.type) {
  case SET_DATA:
    return { ...state, articleData: action.payload.articles };
  case SET_ARTICLE_DATA:
    if(action.payload === null) {
      return { ...state, articleData: [] };
    }
    return { ...state, articleData: action.payload };
  default:
    return state;
  }
}

export default reducer;
